<template>
  <div class="tabs-wrapper">
    <el-tabs v-model="activeId"  closable @tab-remove="removeTab">
      <el-tab-pane v-for="tab in tabsArr" :key="tab.id" :name="tab.id" >
        <span slot="label">
          <i v-if="tab.icon" style="font-weight: 400" class="icon iconfont" :class="tab.icon"></i>
          <el-tooltip v-if="tab.title.length > 20" class="item" effect="dark" :content="tab.title" placement="bottom">
            <span>{{tab.title.slice(0,20)+'...'}}</span>
          </el-tooltip>
          <span v-else>{{tab.title}}</span>
        </span>
        <component :is="tab.componentName" :params="tab.params"></component>
      </el-tab-pane>
    </el-tabs>
    <div class="tab-handle">
      <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-more"></i><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="tab in tabsArr" :key="tab.id" :command="tab.id">{{tab.title}}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
      <span class="close-tab" @click="clearMoreTabs"><i class="el-icon-circle-close-outline"></i>全部关闭</span>
    </div>
  </div>
</template>
<script>
import AllComponents from '../pages/index';
import {mapState,mapMutations} from 'vuex';
export default {
  name:'Tabs',
  data(){
    return {
      activeId:'',
      isDelete:false
    }
  },
  computed:{
    ...mapState([
      'tabsArr',
      'tabActiveId'
    ])
  },
  watch:{
    tabsArr(newval,oldval){
      if(newval.length === 0){
        return;
      }
      if(!this.isDelete){
        this.activeId = newval[newval.length-1].id;
      }
    },
    tabActiveId(newval,oldval){
      if(newval && newval !== this.activeId){
        this.activeId = newval;
        this.RESET_TABACTIVEID();
      }
    }
  },
  methods:{
    ...mapMutations([
      'DELETE_TAB',
      'CLEAR_TABS',
      'RESET_TABACTIVEID'
    ]),
    removeTab(targetId) {
      if(this.tabsArr.length===1){
        this.$message({
          message: '至少保留一个标签!',
          type: 'warning'
        });
        return;
      }
      let tempTab = this.tabsArr.find(item=>{return item.id===targetId});
      if(tempTab && tempTab.isNoSaved){
        this.$confirm('该页面有修改尚未保存，确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteTab(targetId);
        }).catch((err)=>{})
      }else{
        this.deleteTab(targetId);
      }
    },
    deleteTab(targetId){
      this.isDelete = true;
      let tabs = this.tabsArr;
      let activeId = this.activeId;
      if (activeId === targetId) {
        tabs.forEach((tab, index) => {
          if (tab.id === targetId) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeId = nextTab.id;
            }
          }
        });
      }
      this.activeId = activeId;
      this.DELETE_TAB(targetId);
      setTimeout(()=>{
        this.isDelete = false;
      },100);
    },
    handleCommand(command){
      this.activeId = command;
    },
    clearMoreTabs(){
      if(this.tabsArr.length===0){
        return;
      }
      if(!this.activeId){
        this.$message({
          message: '当前未有选中!',
          type: 'warning'
        });
        return;
      }
      this.CLEAR_TABS([this.activeId]);
    }
  },
  components:{
    ...AllComponents
  },
  mounted(){
    if((!this.activeId || this.activeId ==='0') && this.tabsArr.length>0){
      this.activeId = this.tabActiveId||this.tabsArr[this.tabsArr.length-1].id;
    }
  },
  destroyed(){
    this.RESET_TABACTIVEID();
  }
}
</script>
<style lang="scss">
.tabs-wrapper{
  position: relative;
  width:100%;
  min-height: 100%;
  background-color: #fff;
}
.tabs-wrapper .el-tabs__header {
  width: calc(100% - 200px);
  background-color: #fff;
  height: 58px;
  line-height: 58px;
  box-shadow: inset 0 -1px 0 0 #EFF3F5;
}
.tabs-wrapper .el-tabs__nav{
  padding-left: 10px;
}
.tabs-wrapper .el-tabs__item {
  height: 58px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 58px;
  font-weight: 600;
  color: #7A889C;
  letter-spacing: 1px;
}
.tabs-wrapper .el-tabs__item.is-active {
  color: #0D74FF;
}
.tabs-wrapper .el-tabs__active-bar {
  bottom:1px;
  left:16px;
  width: 40px !important;
  background-color: #0D74FF;
}
.tabs-wrapper .el-tabs__nav-next .el-icon-arrow-left:before ,.el-tabs__nav-next .el-icon-arrow-right:before{
  font-size: 20px;
  height: 58px;
  line-height: 58px;
}
.tabs-wrapper .tab-handle{
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 15px;
  width: 185px;
  height: 58px;
  line-height: 58px;
  text-align: right;
  box-shadow: inset 0 -1px 0 0 #EFF3F5;
}
.tabs-wrapper .tab-handle .close-tab{
  display: inline-block;
  height: 27px;
  width: 75px;
  line-height: 27px;
  background: #FFF;
  font-size: 12px;
  color: #8F9AB4;
  text-align: center;
  border: 1px solid #C3CDE1;
  border-radius: 1px;
  cursor: pointer;
}
.tabs-wrapper .tab-handle .close-tab:hover{
  color: #0D74FF;
}
.tabs-wrapper .tab-handle .close-tab i{
  margin-right:3px;
}
.tabs-wrapper .el-dropdown-menu {
  top: 130px !important;
}
.tabs-wrapper .el-dropdown-menu__item {
  line-height: 25px;
  padding: 0 15px;
  font-size: 12px;
}
.tabs-wrapper .el-tabs__nav-wrap::after {
  height:0;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue